import BorderBox3 from './main'
export default function (Vue) {
  Vue.component(BorderBox3.name, BorderBox3)
}



// WEBPACK FOOTER //
// ./src/components/border/border-box-3/index.js